export default "__VITE_ASSET__C6Io3OOh__"